import { useState, useContext, useEffect, useMemo } from 'react';
import DashboardCards from '../components/diskerasure/Cards';
import DeviceTable from '../components/diskerasure/DeviceTable';
import { Box, Container, Modal } from '@mui/material';
import { Select, Button, TextInput } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faWindows, faLinux } from '@fortawesome/free-solid-svg-icons';
import { faWindows as faWindowsBrand, faLinux as faLinuxBrand } from '@fortawesome/free-brands-svg-icons';
import { getCompanyDevices, getCompanyDepartment,getAllDepartments, getAllDevices, addDevices, editLastLogin, editDiskCount, getSYSAuth ,checkDiskChange} from '../apis/axios';
import { getOS, getDrives } from '../apis/agent';
import AuthContext from '../AuthContext';
import { Slab } from 'react-loading-indicators';

function DiskErasure() {
  const auth = useContext(AuthContext);
  const [devices, setDevices] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [addDeviceError, setAddDeviceError] = useState('');
  const [driveData, setDriveData] = useState([]);
  const [loadingDevices, setLoadingDevices] = useState(true);
  const [update, setUpdate] = useState(false);


  const handleUpdate = () => {
    setUpdate(!update);
  };

  const removeKeysExcept = (obj, key1, key2) => {
    obj = JSON.parse(obj);
    const keysToRemove = Object.keys(obj).filter(key => key !== key1 && key !== key2);
    keysToRemove.forEach(key => delete obj[key]);
    return obj;
  };

  const fetchDevices = async () => {
    try {
      setLoadingDevices(true);
      const response = await getCompanyDevices({ company_id: auth.admin });
      //console.log(response)
      if (response && Array.isArray(response.data)) {
        const fetchedDevices = response.data;
        for (const device of fetchedDevices) {
          if (device.id && device.uuid) {
            try {
              const payload = {
                id: device.id,
                uuid: device.uuid,
              };
              const apiResponse = await editLastLogin(payload, device.sys_uuid);
              const checkChange =await checkDiskChange(device.uuid)
              //console.log(checkChange)
              const drivesDetails = await getDrives(device.uuid, device.sys_uuid);
              //console.log(drivesDetails)
              if (parseInt(device.disks.toString().split()[0]) != drivesDetails.data.length) {
                device.disks = drivesDetails.data.length.toString() + " Disks";
                let updatedDiskCount = removeKeysExcept(JSON.stringify(device), 'id', 'disks');
                await editDiskCount(updatedDiskCount);
              }
            } catch (error) {
              console.error(`Error calling editLastLogin for device ID ${device.id}:`, error);
            }
          }
        }
        setDevices(fetchedDevices);
      } else {
        console.error('Invalid response format:', response);
        setDevices([]);
      }
    } catch (error) {
      console.error('Error fetching devices:', error);
      setDevices([]);
    } finally {
      setLoadingDevices(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await getCompanyDepartment(auth.admin);
      if (response && Array.isArray(response.data)) {
        const formattedData = response.data.map(dept => ({
          value: dept.id,
          label: dept.name,
        }));
        setDepartments(formattedData);
      } else {
        console.error('Invalid response format for departments:', response.data);
        setDepartments([]);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    }
  };
  const fetchAllDepartments = async () => {
    try {
      const response = await getAllDepartments(auth.admin);
      if (response && Array.isArray(response.data)) {
        const formattedData = response.data.map(dept => ({
          value: dept.id,
          label: dept.name,
        }));
        setDepartments(formattedData);
      } else {
        console.error('Invalid response format for departments:', response.data);
        setDepartments([]);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    }
  };

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      if (auth.userType === 'antima') {
        const fetchAllDevices = async () => {
          try {
            setLoadingDevices(true);
            const response = await getAllDevices({ company_id: null });
            //console.log(response)
            if (response && Array.isArray(response.data)) {
              const fetchedDevices = response.data;
              for (const device of fetchedDevices) {
                if (device.id && device.uuid) {
                  try {
                    const payload = {
                      id: device.id,
                      uuid: device.uuid,
                    };
                    const apiResponse = await editLastLogin(payload, device.sys_uuid);
                    //console.log(apiResponse)
                    const checkChange =await checkDiskChange(device.uuid)
                    //console.log(checkChange)
                    const drivesDetails = await getDrives(device.uuid, device.sys_uuid);
                    if (parseInt(device.disks.toString().split()[0]) != drivesDetails.data.length) {
                      device.disks = drivesDetails.data.length.toString() + " Disks";
                      let updatedDiskCount = removeKeysExcept(JSON.stringify(device), 'id', 'disks');
                      await editDiskCount(updatedDiskCount);
                    }
                  } catch (error) {
                    console.error(`Error calling editLastLogin for device ID ${device.id}:`, error);
                  }
                }
              }
              setDevices(fetchedDevices);
            } else {
              console.error('Invalid response format:', response);
              setDevices([]);
            }
          } catch (error) {
            console.error('Error fetching devices:', error);
            setDevices([]);
          } finally {
            setLoadingDevices(false);
          }
        };
        await fetchAllDepartments()
        if (!openModal) {
          await fetchAllDevices();
        }
      }
      else if (auth.userType === 'admin' && auth.admin) {
        if (!openModal) {
          await fetchDevices();
        }
        await fetchDepartments();
      } else {
        setDevices([]);
        setDepartments([]);
        setLoadingDevices(false);
      }
    };

    loadData();
  }, [auth.admin, openModal, update]);

  const [formData, setFormData] = useState({
    deviceName: '',
    uuid: '',
    model: '',
    department: '',
    location: '',
    os: '',
    sys_uuid: '',
    disks_info: []
  });
  useEffect(() => {
    setFormData(prev => ({ ...prev, disks_info: driveData.map(drive => drive.serial_number), }));
  }, [driveData]);
  const [osFetchStatus, setOsFetchStatus] = useState('');
  const [fetchingOs, setFetchingOs] = useState(false);
  const [fetchingDrives, setFetchingDrives] = useState(false);
  const [drivesFetchStatus, setDrivesFetchStatus] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('All Departments');
  const [osFilter, setOsFilter] = useState('All OS Types');

  const departmentOptions = ['All Departments', ...new Set(devices.map(item => item.department_name).filter(Boolean))];
  const osTypes = ['All OS Types', ...new Set(devices.map(item => item.os).filter(Boolean))];

  const filteredData = useMemo(() => {
    return devices.filter(item => {
      const matchesDepartment = departmentFilter === 'All Departments' || item.department_name === departmentFilter;
      const matchesOs = osFilter === 'All OS Types' || item.os === osFilter;
      return matchesDepartment && matchesOs;
    });
  }, [devices, departmentFilter, osFilter]);

  useEffect(() => {
    if (devices.length > 0) {
      //console.log('FilteredData after devices fetched:', filteredData);
    }
  }, [devices, filteredData]);

  const handleInputChange = (field, value) => {
    if (field === 'uuid') {
      setFormData(prev => ({
        ...prev,
        os: '',
        sys_uuid: '',
        [field]: value,
      }));
      setOsFetchStatus('');
      setDrivesFetchStatus('');
      setDriveData([]);
      if (!value) {
        setOsFetchStatus('Please enter a UUID');
      }
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };
  const handleFetchOs = async () => {
    if (!formData.uuid) {
      setOsFetchStatus('Please enter a UUID');
      return;
    }

    setFetchingOs(true);
    setOsFetchStatus('Fetching OS...');
    try {
      const osResponse = await getOS(formData.uuid);
      //console.log(osResponse)
      const osName = osResponse.data.system || 'Unknown OS';
      const sysUuid = osResponse.data.sys_uuid || 'Unknown UUID';
      setFormData(prev => ({
        ...prev,
        os: osName,
      }));
      setOsFetchStatus('OS Fetched successfully');
      //console.log(sysUuid)
      const res = await getSYSAuth({ sys_uuid: sysUuid })

      const encUuid = res.data.encrypted_sys_uuid
      setFormData(prev => ({
        ...prev,
        sys_uuid: encUuid,
      }));
      //console.log(encUuid)
      setFetchingDrives(true);
      setDrivesFetchStatus('Fetching Disks...');
      const drivesResponse = await getDrives(formData.uuid, encUuid);
      if (drivesResponse && Array.isArray(drivesResponse.data)) {
        setDriveData(drivesResponse.data);
        setDrivesFetchStatus(`Found ${drivesResponse.data.length} Disk${drivesResponse.data.length !== 1 ? 's' : ''}`);
      } else {
        setDriveData([]);
        setDrivesFetchStatus('No Disks found');
      }
    } catch (error) {
      console.error('Error fetching OS or drives:', error);
      if (error.message.includes('OS')) {
        setFormData(prev => ({
          ...prev,
          os: '',
          sys_uuid: '',
        }));
        setOsFetchStatus(`${error.message.includes('Network Error') ? 'Agent is not online' : 'Invalid UUID'}`);
      } else {
        setDriveData([]);
        setDrivesFetchStatus('Failed to fetch Disks');
      }
    } finally {
      setFetchingOs(false);
      setFetchingDrives(false);
    }
  };

  const handleAddDevice = async () => {
    const driveCount = driveData.length;
    //console.log(driveCount)
    const newDevice = {
      name: formData.deviceName,
      uuid: formData.uuid,
      location: formData.location,
      model: formData.model,
      department_id: parseInt(formData.department),
      os: formData.os,
      sys_uuid: formData.sys_uuid,
      disks: `${driveCount} Disk${driveCount !== 1 ? 's' : ''}`,
      disks_info: formData.disks_info
    };

    try {
      const response = await addDevices(newDevice);
      if (response.data.status === 'success') {
        await fetchDevices();
        setAddDeviceError('');
        setOpenModal(false);
        setFormData({
          deviceName: '',
          uuid: '',
          model: '',
          department: '',
          location: '',
          os: '',
          sys_uuid: ''
        });
        setOsFetchStatus('');
        setDrivesFetchStatus('');
        setDriveData([]);
      } else {
        setAddDeviceError(response.data.message);
      }
    } catch (error) {
      console.error('Error adding device:', error);
      setAddDeviceError(error.response?.data?.message || 'Failed to add device. Please try again.');
    }
  };

  const handleRippleEffect = (e) => {
    const button = e.currentTarget;
    const ripple = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
    ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
    ripple.classList.add('export-button-ripple');

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  if (loadingDevices) {
    return (
      <Box display="flex" sx={{ maxWidth: 'none', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Slab color="#FF7A00" size="medium" />
      </Box>
    );
  }

  return (
    <Box display="flex" sx={{ maxWidth: 'none', justifyContent: 'center' }}>
      <Box flexGrow={1} ml={{ sm: 0 }} sx={{ maxWidth: 'none' }}>
        <Container
          className="py-4"
          sx={{
            maxWidth: 'none !important',
            overflowX: 'hidden',
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <div style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
            <div className="flex justify-between items-center mb-4">
              <h1
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '32px',
                    fontWeight: 700,
                    color: '#202224',
                  }}
                >
                Disk Erasure
              </h1>
              <Button
                size="sm"
                variant="filled"
                className="export-button"
                styles={{
                  root: {
                    width: '120px',
                    height: '36px',
                    backgroundColor: '#FF7A00',
                    borderRadius: '20px',
                    padding: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    border: 'none',
                    cursor: 'pointer',
                    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                    '&:hover': {
                      backgroundColor: '#FF7A00',
                    },
                  },
                  label: {
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  },
                }}
                onClick={(e) => {
                  handleRippleEffect(e);
                  setOpenModal(true);
                }}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    height: '10px',
                    width: '10px',
                    color: '#fff',
                  }}
                />
                <span>Add Devices</span>
              </Button>
            </div>
            <div className="flex flex-wrap gap-4 md:gap-[30px] mb-6">
              <Select
                value={departmentFilter}
                onChange={setDepartmentFilter}
                data={departmentOptions}
                placeholder="All Departments"
                styles={{
                  input: {
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#202224',
                    border: '0.6px solid #202224',
                    backgroundColor: '#FCFDFD',
                    borderRadius: '6px',
                    height: '36px',
                    width: '180px',
                    '&:focus': {
                      borderColor: '#FF6B00',
                      outline: 'none',
                    },
                  },
                  item: {
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '12px',
                    color: '#202224',
                    '&[data-selected]': {
                      backgroundColor: '#FF6B00',
                      color: '#FFFFFF',
                      '&:hover': {
                        backgroundColor: '#FF6B00',
                        color: '#FFFFFF',
                      },
                    },
                    '&:hover': {
                      backgroundColor: '#FFF3E5',
                    },
                  },
                }}
              />
              <Select
                value={osFilter}
                onChange={setOsFilter}
                data={osTypes}
                placeholder="All OS Types"
                styles={{
                  input: {
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#202224',
                    border: '0.6px solid #202224',
                    backgroundColor: '#FCFDFD',
                    borderRadius: '6px',
                    height: '36px',
                    width: '180px',
                    '&:focus': {
                      borderColor: '#FF6B00',
                      outline: 'none',
                    },
                  },
                  item: {
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '12px',
                    color: '#202224',
                    '&[data-selected]': {
                      backgroundColor: '#FF6B00',
                      color: '#FFFFFF',
                      '&:hover': {
                        backgroundColor: '#FF6B00',
                        color: '#FFFFFF',
                      },
                    },
                    '&:hover': {
                      backgroundColor: '#FFF3E5',
                    },
                  },
                }}
              />
            </div>
            <div>
              <DashboardCards />
            </div>
            <div>
              {devices.length > 0 ? (
                <DeviceTable data={filteredData} handleUpdate={handleUpdate} />
              ) : (
                <div>No devices available</div>
              )}
            </div>
            <Modal
              open={openModal}
              onClose={() => {
                setOpenModal(false);
                setFormData({
                  deviceName: '',
                  uuid: '',
                  model: '',
                  department: '',
                  location: '',
                  os: '',
                  sys_uuid: ''
                });
                setOsFetchStatus('');
                setDrivesFetchStatus('');
                setDriveData([]);
                setAddDeviceError('');
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  backgroundColor: '#F7F7F7',
                  padding: '20px 30px',
                  borderRadius: '8px',
                  width: '90vw',
                  maxWidth: '900px',
                  position: 'relative',
                  maxHeight: { xs: '90vh', sm: '80vh' },
                  boxShadow: '6px 6px 6px #00000040',
                }}
              >
                <div className="flex justify-between items-center mb-4">
                  <h1
                    style={{
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: '30px',
                      fontWeight: 700,
                      color: '#202224',
                    }}
                  >
                    Add New Device
                  </h1>
                  <FontAwesomeIcon
                    icon={faTimes}
                    style={{
                      height: '17px',
                      width: '17px',
                      color: '#FF7A00',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setOpenModal(false);
                      setFormData({
                        deviceName: '',
                        uuid: '',
                        model: '',
                        department: '',
                        location: '',
                        os: '',
                        sys_uuid: ''
                      });
                      setOsFetchStatus('');
                      setDrivesFetchStatus('');
                      setDriveData([]);
                      setAddDeviceError('');
                    }}
                  />
                </div>
                <h2
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: { xs: '18px', sm: '20px' },
                    fontWeight: 700,
                    color: '#202224',
                    marginBottom: '16px',
                  }}
                >
                  Device Information
                </h2>
                <div className="flex flex-col sm:flex-row gap-3 mb-4">
                  <div className="flex flex-col flex-1">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: 600,
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      Device Name*
                    </label>
                    <TextInput
                      value={formData.deviceName}
                      onChange={(e) => handleInputChange('deviceName', e.target.value)}
                      placeholder="e.g., WS-IT-001"
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#FCFCFC',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                      }}
                    />
                  </div>
                  <div className="flex flex-col flex-1">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: 600,
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      UUID*
                    </label>
                    <TextInput
                      value={formData.uuid}
                      onChange={(e) => handleInputChange('uuid', e.target.value)}
                      placeholder="e.g., agent001"
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#FCFCFC',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                      }}
                    />
                  </div>
                  <div className="flex flex-col flex-1">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: 600,
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      Model*
                    </label>
                    <TextInput
                      value={formData.model}
                      onChange={(e) => handleInputChange('model', e.target.value)}
                      placeholder="e.g., Dell Latitude 7420"
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#FCFCFC',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 mb-4">
                  <div className="flex flex-col flex-1">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: 600,
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      Department*
                    </label>
                    <Select
                      value={formData.department}
                      onChange={(value) => handleInputChange('department', value)}
                      data={departments}
                      placeholder={departments.length === 0 ? 'No departments available' : 'Select Department'}
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#FCFCFC',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                        item: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          '&[data-selected]': {
                            backgroundColor: '#FF6B00',
                            color: '#FFFFFF',
                            '&:hover': {
                              backgroundColor: '#FF6B00',
                              color: '#FFFFFF',
                            },
                          },
                          '&:hover': {
                            backgroundColor: '#FFF3E5',
                          },
                        },
                      }}
                    />
                  </div>
                  <div className="flex flex-col flex-1">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: '600',
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      Location*
                    </label>
                    <TextInput
                      value={formData.location}
                      onChange={(e) => handleInputChange('location', e.target.value)}
                      placeholder="e.g., HQ - Third Floor"
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#FCFCFC',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    borderTop: '1px solid #E0E0E0',
                    margin: '16px 0',
                  }}
                />
                <h2
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: { xs: '18px', sm: '20px' },
                    fontWeight: 700,
                    color: '#202224',
                    marginBottom: '16px',
                  }}
                >
                  System Operation
                </h2>
                <div className="mb-4">
                  <div className="flex flex-col location-field-container">
                    <label
                      style={{
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        fontWeight: 600,
                        color: '#202224',
                        marginBottom: '6px',
                      }}
                    >
                      Operating System*
                    </label>
                    <TextInput
                      value={formData.os}
                      readOnly
                      placeholder="OS will be fetched after entering UUID"
                      styles={{
                        input: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '10px', sm: '12px' },
                          color: '#595C60',
                          backgroundColor: '#EDEDED',
                          border: '0.6px solid #595C60',
                          borderRadius: '6px',
                          width: '100%',
                          maxWidth: { xs: '100%', sm: '270px' },
                          height: { xs: '36px', sm: '40px' },
                          display: 'flex',
                          alignItems: 'center',
                          paddingRight: '30px',
                          boxSizing: 'border-box',
                          '&:focus': {
                            borderColor: '#FF6B00',
                            outline: 'none',
                          },
                        },
                        root: {
                          width: '100%',
                        },
                      }}
                      rightSection={
                        formData.os && (
                          <FontAwesomeIcon
                            icon={
                              formData.os.toLowerCase().includes('windows')
                                ? faWindowsBrand
                                : faLinuxBrand
                            }
                            style={{
                              color: formData.os.toLowerCase().includes('windows')
                                ? '#00B0FF'
                                : '#202224',
                              marginRight: '10px',
                            }}
                          />
                        )
                      }
                    />
                    <Button
                      className="export-button fetch-os-button"
                      styles={{
                        root: {
                          width: { xs: '100px !important', sm: '120px !important' },
                          minWidth: { xs: '100px !important', sm: '120px !important' },
                          maxWidth: { xs: '100px !important', sm: '120px !important' },
                          height: { xs: '32px', sm: '36px' },
                          backgroundColor: '#FF7A00',
                          borderRadius: '20px',
                          padding: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: 'none',
                          cursor: 'pointer',
                          boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                          marginTop: '8px',
                          alignSelf: { xs: 'flex-start', sm: 'flex-start' },
                          '&:hover': {
                            backgroundColor: '#FF7A00',
                          },
                        },
                        label: {
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '12px', sm: '14px' },
                          fontWeight: 500,
                          color: '#fff',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        },
                      }}
                      onClick={(e) => {
                        handleRippleEffect(e);
                        handleFetchOs();
                      }}
                      disabled={fetchingOs || fetchingDrives || !formData.uuid}
                    >
                      {fetchingOs || fetchingDrives ? 'Fetching...' : 'Fetch OS'}
                    </Button>
                    {osFetchStatus && (
                      <span
                        style={{
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '8px', sm: '10px' },
                          color: osFetchStatus.includes('successfully') ? '#2ECC71' : '#E74C3C',
                          marginTop: '6px',
                        }}
                      >
                        {osFetchStatus}
                      </span>
                    )}
                    {drivesFetchStatus && (
                      <span
                        style={{
                          fontFamily: 'Nunito Sans, sans-serif',
                          fontSize: { xs: '8px', sm: '10px' },
                          color: drivesFetchStatus.includes('Found') ? '#2ECC71' : '#E74C3C',
                          marginTop: '6px',
                        }}
                      >
                        {drivesFetchStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    borderTop: '1px solid #E0E0E0',
                    margin: '16px 0',
                  }}
                />
                {addDeviceError && (
                  <div
                    style={{
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: { xs: '10px', sm: '12px' },
                      color: '#E74C3C',
                      marginBottom: '16px',
                      textAlign: 'center',
                    }}
                  >
                    {addDeviceError}
                  </div>
                )}
                <div className="flex justify-end">
                  <Button
                    className="export-button"
                    styles={{
                      root: {
                        width: { xs: '100px', sm: '120px' },
                        height: { xs: '32px', sm: '36px' },
                        backgroundColor: '#FF7A00',
                        borderRadius: '20px',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                        '&:hover': {
                          backgroundColor: '#FF7A00',
                        },
                      },
                      label: {
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '12px', sm: '14px' },
                        fontWeight: 500,
                        color: '#fff',
                      },
                    }}
                    onClick={(e) => {
                      handleRippleEffect(e);
                      handleAddDevice();
                    }}
                    disabled={!formData.deviceName || !formData.uuid || !formData.model || !formData.department || !formData.location || !formData.os || !formData.sys_uuid || driveData.length === 0}
                  >
                    Add Device
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
        </Container>
      </Box>
      <style>
        {`
          .export-button {
            position: relative;
            overflow: hidden;
          }
          .export-button-ripple {
            position: absolute;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.4);
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
          }
          @keyframes ripple {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }
          .fetch-os-button {
            width: 120px !important;
          }
          @media (max-width: 600px) {
            .fetch-os-button {
              width: 100px !important;
            }
          }
          .location-field-container {
            max-width: 100%;
          }
          @media (min-width: 600px) {
            .location-field-container {
              max-width: 270px !important;
            }
          }
        `}
      </style>
    </Box>
  );
}

export default DiskErasure;